$(function () {
    let currentBreakpoint = null;
    const breakpointCheck = '<div id="bpHelper" style="position: absolute; left: -1000px;"><div class="d-none d-sm-block d-md-none">sm</div><div class="d-none d-md-block d-lg-none">md</div><div class="d-none d-lg-block d-xl-none">lg</div><div class="d-none d-xl-block d-xxl-none">xl</div><div class="d-none d-xxl-block">xxl</div></div>';
    const updateBreakpoint = function() {
        const bpHelper = $(breakpointCheck).appendTo('body');
        const newBreakpoint = bpHelper.children(':visible').text() || 'xs';
        bpHelper.remove();
        if (newBreakpoint !== 'xs' && newBreakpoint === currentBreakpoint) { return; }
        currentBreakpoint = newBreakpoint;
        $('[data-clamp]').each(function () {
            const $this = $(this);
            if (!$this.data('loaded')) {
                $this.data('text', $this.html());
                $this.data('loaded', true);
            } else {
                $this.html($this.data('text')); // re-add the text so it can be clamped again
            }
            $clamp(this, { clamp: $this.data('clamp-' + currentBreakpoint) || $this.data('clamp') || 3 });
        });
    }
    $(window).on('resize', function () {
        updateBreakpoint();
    });
    updateBreakpoint();
});